var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drawer",class:[{left: _vm.left }, {open:_vm.isOpen}, _vm.widthCss],style:({right: _vm.isOpen ? 0 : '-' + _vm.width, width: _vm.width})},[_c('div',{staticClass:"uiDrawerInner"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }